import { FocusMonitor } from "@angular/cdk/a11y"
import { coerceBooleanProperty } from "@angular/cdk/coercion"
import { COMMA, ENTER } from "@angular/cdk/keycodes"
import { CommonModule } from "@angular/common"
import { Component, ElementRef, Input, OnDestroy, OnInit, Optional, Self, ViewChild } from "@angular/core"
import { FlexLayoutModule } from "@angular/flex-layout"
import { FormControl, FormGroupDirective, NgControl, NgForm, ReactiveFormsModule } from "@angular/forms"
import { MatAutocompleteModule, MatAutocompleteTrigger } from "@angular/material/autocomplete"
import { MatButtonModule } from "@angular/material/button"
import { MatChipInputEvent, MatChipsModule } from "@angular/material/chips"
import { MatFormFieldControl } from "@angular/material/form-field"
import { MatIconModule } from "@angular/material/icon"
import { MatInputModule } from "@angular/material/input"
import { TranslateModule } from "@ngx-translate/core"
import { isArray, isString } from "lodash"
import { Subject } from "rxjs"

import { isValidICDCode } from "../../../../shared/src/lib/utils"
import { CustomMaterialInputControlComponent } from "../custom-field"

@Component({
  selector: 'mmx-diagnosis-code-chips-selector',
  templateUrl: './diagnosis-code-chips-selector.component.html',
  styleUrls: ['./diagnosis-code-chips-selector.component.scss'],
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: DiagnosisCodeChipsSelectorComponent,
    },
  ],
  imports: [
    CommonModule,
    MatChipsModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TranslateModule,
  ],
})
export class DiagnosisCodeChipsSelectorComponent
  extends CustomMaterialInputControlComponent<string[]>
  implements OnInit, OnDestroy
{
  @ViewChild('icdCodeChipGrid') selectCptInput: ElementRef
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger

  public readonly separatorKeysCodes = [ENTER, COMMA]

  @Input() noCopyPaste: boolean
  @Input() multiple = false

  // TODO: Handle full model response
  // @Input() fullResponse = false

  public get value(): string[] | null {
    return this._value ? this._value : []
  }

  // _value is an array, add unique values to the array when setting this property
  public set value(input: string | string[] | null) {
    const valueSet = new Set<string>()

    if (isArray(input)) {
      input.forEach(code => {
        const trimmedCode = code.trim()
        if (isValidICDCode(trimmedCode)) {
          valueSet.add(trimmedCode)
        }
      })
    } else if (isString(input) && isValidICDCode(input)) {
      valueSet.add(input)
    }

    super.value = Array.from(valueSet)
  }

  icdCodeControl = new FormControl<string>(null)
  filterControl = new FormControl<string>(null)

  // TODO: Handle autcomplete capability
  // icdCodes: any[] = []

  // set values(codes: string[]) {
  //   const values = uniqWith(concat(this._value, codes), isEqual)
  //   this.value = values
  //   this.icdCodeControl.setValue(null)
  //   this.autocomplete.closePanel()
  // }

  get isMultiple(): boolean {
    return coerceBooleanProperty(this.multiple)
  }

  // TODO: Return full ICD Code
  // get isFull(): boolean {
  //   return coerceBooleanProperty(this.fullResponse)
  // }

  private onDestroy$ = new Subject<void>()
  constructor(
      @Optional() @Self() public ngControl: NgControl,
      @Optional() protected parentForm: NgForm,
      @Optional() protected parentFormGroup: FormGroupDirective,
      protected fm: FocusMonitor,
      protected elRef: ElementRef,
    // TODO: Implement service for querying the code
  ) {
    super(ngControl, parentForm, parentFormGroup, fm, elRef)
  }

  removeSelectedCode(code: string) {
    this.value = this.value.filter((c) => {
      return c !== code
    })
  }

  public addCode(e: MatChipInputEvent) {
    this.value = Array.from(
      new Set([...this.value, ...(e.value || '').toUpperCase().trim().split(',')]),
    )

    e.chipInput?.clear()
  }

  // TODO: Implement filtering with auto complete
  // selected(event: MatAutocompleteSelectedEvent): void{
  // }

  removeAllCodes() {
    this.value = []
  }

  copySelectedValue() {
    const text = (this.value || [])
    // .map((item) =>
    //   typeof item === 'string' ? item : this.getItemId(item),
    // )
    const selBox = document.createElement('textarea')
    selBox.style.position = 'fixed'
    selBox.style.left = '0'
    selBox.style.top = '0'
    selBox.style.opacity = '0'
    selBox.value = text.join(',')
    document.body.appendChild(selBox)
    selBox.focus()
    selBox.select()
    document.execCommand('copy')
    document.body.removeChild(selBox)
  }

  focus() {
    this.selectCptInput.nativeElement.focus()
  }

  ngOnInit() {
    super.ngOnInit()
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}